__turbopack_context__.v({
  "ctaRow": "Jr5BAa_ctaRow",
  "pill": "Jr5BAa_pill",
  "pillOutline": "Jr5BAa_pillOutline",
  "pillPrimary": "Jr5BAa_pillPrimary",
  "pillUnderline": "Jr5BAa_pillUnderline",
});
